<template>
  <tab-layout :full-width="true">
    <div slot="tabContent" class="bg-white rounded mb-4 p-3">
      <page-heading>Draws</page-heading>

      <div v-if="!loading && drafts.length === 0" class="text-muted py-4 text-center">
        No draws are currently available.
      </div>

      <div v-for="draft in drafts" :key="draft.id" class="mb-5">
        <div class="draws-dashboard__draft">
          <div class="draws-dashboard__header">
            <span class="draws-dashboard__draft-name">{{ draft.name }}</span>
          </div>
          <ul v-if="draft.events && draft.events.length" class="draws-dashboard__events">
            <template v-for="event in draft.events">
              <li v-if="isEventVisible(event)" :key="event.id" class="draws-dashboard__event">
                <router-link v-if="eventDrawsCount(event) > 0" :to="`/draws/public/${event.id}/1`">
                  {{ event.name }}
                </router-link>
                <span v-else>{{ event.name }}</span>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </tab-layout>
</template>

<script>
import { defineComponent, onMounted } from '@vue/composition-api'
import TabLayout from '@/components/TabLayout'
import PageHeading from '@/components/PageHeading'
import useDrawsPublicDashboard from '@/composables/draws/useDrawsPublicDashboard'
import { EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_FINAL } from '@/constants/eventSplitKind'

export default defineComponent({
  name: 'DrawsPublicList',
  components: { TabLayout, PageHeading },
  setup() {
    const { drafts, loading, fetchDashboard } = useDrawsPublicDashboard()

    function isSplitFinal(event) {
      return event.split_kind === EVENT_SPLIT_KIND_COMBINED_CONJUNCTION_FINAL
    }

    function isEventVisible(event) {
      if (event.has_nominations) return true
      if (isSplitFinal(event)) return true
      return event.parent_draws_count > 0
    }

    function eventDrawsCount(event) {
      if (event.draws_count > 0) return event.draws_count
      if (event.parent_draws_count > 0) return event.parent_draws_count
      return 0
    }

    onMounted(() => {
      fetchDashboard()
    })

    return { drafts, loading, isEventVisible, eventDrawsCount }
  }
})
</script>

<style scoped>
.draws-dashboard__draft {
  border: 1px solid #dee2e6;
}

.draws-dashboard__header {
  background-color: #e9ecef;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #dee2e6;
}

.draws-dashboard__draft-name {
  font-size: 1.25rem;
  font-weight: 700;
}

.draws-dashboard__events {
  list-style: none;
  margin: 0;
  padding: 0;
}

.draws-dashboard__event {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #dee2e6;
}

.draws-dashboard__event:last-child {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Draws/PublicList/DrawsPublicList.vue